var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"canvas-wrapper"},[_c('div',{ref:"canvas",staticClass:"canvas",attrs:{"id":"canvas"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }